import jwt_decode from 'jwt-decode';
import * as ActionTypes from './EnumTypes/ActionEnumTypes';
import {EnumTypes} from 'Models/EnumTypes/UserEnumTypes';
import * as UserActionModel from './Models/UserActionModel';
import * as UserModule from './../../Modules/UserModule';
import moment from 'moment';
import * as ViewManagementModule from './../../Modules/ViewManagementModule';
import * as InfinityTableModule from "Modules/InfinityTableModule";
import {change, reset} from 'redux-form';
import {history} from 'HelperFunctions/root';
import API from 'Connectors/_main';
import * as ErrorActions from './ErrorActions';
import {EnumTypes as ErrorEnumType} from './../../Models/EnumTypes/ErrorEnumTypes';
import * as Dictionary from 'Models/Dictionary';
import i18n from './../../Translations/_i18n';
import * as ErrorEnumTypes from 'Models/EnumTypes/ErrorEnumTypes'
import APIModule from 'API'
import {Province} from "API/Region/Region.Enums";
import {GetCountiesResponse, GetVoivodeshipResponse} from "API/Region/Region.Models";
import {OptionsElement} from 'Models/ViewManagementModel'
import {saveMigrationToken, tryMigrationLogin} from 'components/MigrationModal/Services/migrationLogin.Service'

function loginUser(email: string, password: string) {
    return async dispatch => {
        try {
            const userData = await UserModule.Connector.LogInUser({email, password});
            dispatch(ErrorActions.setNewsForMoment(null));

            if (userData.data.user.roleName === EnumTypes.RoleName.TECHNICIAN) {
                dispatch(ErrorActions.setNewsForMoment({
                    type: ErrorEnumTypes.EnumTypes.NewsType.ERROR,
                    message: i18n.t('dictionary:LOGIN_NOT_PERMISSION_ERROR_MESSAGE')
                }));
            } else if (userData.data.user.roleName === EnumTypes.RoleName.ALBATROSS) {
                dispatch(ErrorActions.setNewsForMoment({
                    type: ErrorEnumTypes.EnumTypes.NewsType.ERROR,
                    message: i18n.t('dictionary:LOGIN_ALBATROSS_USER_MESSAGE')
                }));
            } else {
                // Logowanie do 1.0 sie udalo - probujemy tymi samymi danymi zautoryzowac w 2.0.
                // Token = przenosimy uzytkownika do 2.0, odmowa 2.0 = prosimy o haslo z panelu klienta
                // VEHIS (bez wpuszczania na 1.0), blad techniczny = user pracuje dalej na 1.0.
                // ADMIN zostaje na 1.0 (bez auto-przeniesienia w _App), wiec odmowa 2.0 nie moze go blokowac -
                // token probujemy zdobyc tylko po to, zeby pasek info pokazal mu przycisk przejscia do 2.0.
                const migration = await tryMigrationLogin(email, password);
                const isAdmin = userData.data.user.roleName === EnumTypes.RoleName.ADMIN;

                if (migration.status === 'denied' && !isAdmin) {
                    saveMigrationToken(null);
                    dispatch(ErrorActions.setNewsForMoment({
                        type: ErrorEnumTypes.EnumTypes.NewsType.ERROR,
                        message: i18n.t('dictionary:LOGIN_MIGRATION_USE_VEHIS_PASSWORD_MESSAGE')
                    }));
                } else {
                    // Zapis przed loginUserSuccess, zeby byl gotowy na pierwszy render po zalogowaniu.
                    saveMigrationToken(migration.status === 'ok' ? migration.token : null);
                    dispatch(loginUserSuccess(userData.data));
                }
            }
        } catch (err) {
            dispatch(loginUserFailure(err.response ? err.response.data : null));
        }
        dispatch(ViewManagementModule.Actions.hideLoader());
    };
}

function resetPassword(formData: UserModule.Types.RequestPasswordResetRequest) {
    return async dispatch => {
        try {
            await UserModule.Connector.resetPassword(formData.email);
            dispatch(reset('resetPassword'));
            dispatch(resetPasswordSuccess());
        } catch (err) {
            dispatch(resetPasswordFailure(err.response.data));
        }
    };
}

function resetPasswordConfirm(formData: UserModule.Types.PasswordResetRequest) {
    return async dispatch => {
        try {
            await UserModule.Connector.resetPasswordConfirm(formData);
            dispatch(reset('resetPasswordConfirm'));
            dispatch(resetPasswordConfirmSuccess());
        } catch (err) {
            dispatch(resetPasswordConfirmFailure(err && err.response ? err.response.data : null));
        }
    };
}

function changePassword(formData: UserModule.Types.ChangePasswordRequest) {
    return async dispatch => {
        try {
            const userData = await UserModule.Connector.changePassword(formData);
            dispatch(changePasswordSuccess());
            dispatch(loginUserSuccess(userData));
            localStorage.clear();
            localStorage.setItem('token', userData.token);
            dispatch(reset('passwordManagementForm'));
        } catch (err) {
            dispatch(changePasswordFailure(err && err.response ? err.response.data : null));
        }
    };
}

function checkIfTokenIsNotExpired() {
    return async dispatch => {
        const token: string = localStorage.getItem('token');
        if (token) {
            const tokenDecode: { exp: number; iat: number } = jwt_decode(token);
            const expDate = moment(tokenDecode.exp * 1000);
            const addDate = moment(tokenDecode.iat * 1000);
            const timeLeft = expDate.diff(moment(), 'seconds');
            const difference = expDate.diff(addDate, 'seconds');
            const percentageDifference = ((difference - timeLeft) / difference) * 100;
            if (percentageDifference > 70) {
                try {
                    const newToken = await UserModule.Connector.refreshToken();
                    dispatch(loginUserSuccess(newToken));
                    localStorage.setItem('token', newToken.token);
                    API.defaults.headers.common['Authorization'] = `bearer ${newToken.token}`;
                } catch (err) {
                    if (err.response && err.response.status === 401) {
                        dispatch(logOutUser());
                        history.push(`/`);
                    }
                }
            }
        }
    };
}

function checkUser() {
    return async dispatch => {
        const token: string = localStorage.getItem('token');
        if (token) {
            const tokenDecode: { exp: number; iat: number } = jwt_decode(token);
            const expDate = moment(tokenDecode.exp * 1000);
            const addDate = moment(tokenDecode.iat * 1000);
            const timeLeft = expDate.diff(moment(), 'hours');
            const difference = expDate.diff(addDate, 'hours');
            const percentageDifference = ((difference - timeLeft) / difference) * 100;
            if (percentageDifference > 70) {
                try {
                    const newToken = await UserModule.Connector.refreshToken();
                    dispatch(loginUserSuccess(newToken));
                    localStorage.setItem('token', newToken.token);
                    API.defaults.headers.common['Authorization'] = `bearer ${newToken.token}`;
                } catch (err) {
                    if (err.response && err.response.status === 401) {
                        dispatch(logOutUser());
                        history.push(`/`);
                    }
                }
            } else {
                try {
                    const currentUser = await UserModule.Connector.currentUser();
                    dispatch(
                        loginUserSuccess({
                            user: currentUser.data.user,
                            token
                        })
                    );
                } catch (err) {
                    dispatch(logOutUser());
                    history.push(`/`);
                }
            }
            dispatch(ViewManagementModule.Actions.hideLoader());
        } else {
            dispatch(ViewManagementModule.Actions.hideLoader());
            dispatch(noActiveUserFound());
        }
    };
}

function createUser(newUserData: UserModule.Types.CreateUserAccountForm) {
    this.setAdminData = _setAdminData;

    this.setFleetOwnerData = _setFleetOwnerData;

    this.setTechnicianData = _setTechnicianData;
    this.setExternalData = _setExternalData;

    return async dispatch => {
        try {

            let newUserDataTemp;

            switch (newUserData.roleName.value) {
                case UserModule.UserEnumTypes.RoleName.ADMIN:
                    newUserDataTemp = this.setAdminData(newUserData);
                    await UserModule.Connector.createNewAdmin(newUserDataTemp);
                    break;
                case UserModule.UserEnumTypes.RoleName.FLEET_OWNER:
                    newUserDataTemp = this.setFleetOwnerData(newUserData);
                    await UserModule.Connector.createNewFleetOwner(newUserDataTemp);
                    break;
                case UserModule.UserEnumTypes.RoleName.TECHNICIAN:
                    newUserDataTemp = this.setTechnicianData(newUserData);
                    await UserModule.Connector.createNewTechnician(newUserDataTemp);
                    break;
                case UserModule.UserEnumTypes.RoleName.EXTERNAL:
                    newUserDataTemp = this.setExternalData(newUserData);
                    await UserModule.Connector.createNewExternal(newUserDataTemp);
                    break;
                default:
                //g
            }

            dispatch(reset('addUserForm'));
            // dispatch(getUserList());
            dispatch(createUserSuccess());
            dispatch(setUserRoleFilter(newUserData.roleName.value));

            dispatch(ErrorActions.setNewsForMoment({
                type: ErrorEnumType.NewsType.SUCCESS,
                message: i18n.t('forms:createUserSuccess')
            }));
            clearCreateUserStatus();

            const {USER_MANAGEMENT} = ViewManagementModule.EnumTypes.Page;
            history.push(`${Dictionary.PageUrl.get(USER_MANAGEMENT)}`);
        } catch (err) {
            dispatch(createUserFailure(err && err.response ? err.response.data : null));
        }
    };
}

function _setAdminData(data: UserModule.Types.CreateUserAccountForm): UserModule.Types.ModifyUAdminAccountRequest {
    return {
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
        phoneNumber: data.phoneNumber
    }
}

function _setExternalData(data: UserModule.Types.CreateUserAccountForm): UserModule.Types.ModifyUAdminAccountRequest {
    return {
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
        phoneNumber: data.phoneNumber
    }
}

function _setFleetOwnerData(data: UserModule.Types.CreateUserAccountForm): UserModule.Types.ModifyUFleetOwnerAccountRequest {
    return {
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
        phoneNumber: data.phoneNumber,
        accountingEmail: data.accountingEmail
    }
}

function _setTechnicianData(data: UserModule.Types.CreateUserAccountForm): UserModule.Types.ModifyUTechnicianAccountRequest {

    const insuranceEndDate = moment(data.insuranceEndDate).format("YYYY-MM-DD");
    const criminalBackgroundCheck = (!data.criminalBackgroundCheck) ? false : data.criminalBackgroundCheck;

    return {
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
        phoneNumber: data.phoneNumber,
        city: data.city,
        insuranceEndDate,
        companyName: data.companyName,
        criminalBackgroundCheck,
        provinces: data.provinces,
        countyIds: data.countyIds,
    }
}

function updateUser(userId: number, newUserData: UserModule.Types.CreateUserAccountForm) {

    this.setAdminData = _setAdminData;

    this.setFleetOwnerData = _setFleetOwnerData;

    this.setTechnicianData = _setTechnicianData;
    this.setExternalData = _setExternalData;

    return async dispatch => {
        try {

            let newUserDataTemp;

            switch (newUserData.roleName.value) {
                case UserModule.UserEnumTypes.RoleName.ADMIN:
                    newUserDataTemp = this.setAdminData(newUserData);
                    await UserModule.Connector.updateAdmin(userId, newUserDataTemp);
                    break;
                case UserModule.UserEnumTypes.RoleName.FLEET_OWNER:
                    newUserDataTemp = this.setFleetOwnerData(newUserData);
                    await UserModule.Connector.updateFleetOwner(userId, newUserDataTemp);
                    break;
                case UserModule.UserEnumTypes.RoleName.TECHNICIAN:
                    newUserDataTemp = this.setTechnicianData(newUserData);
                    await UserModule.Connector.updateTechnician(userId, newUserDataTemp);
                    break;
                case UserModule.UserEnumTypes.RoleName.EXTERNAL:
                    newUserDataTemp = this.setExternalData(newUserData);
                    await UserModule.Connector.updateExternal(userId, newUserDataTemp);
                    break;
                default:
                //g
            }
            dispatch(reset('addUserForm'));
            // dispatch(getUserList());
            dispatch(createUserSuccess());

            dispatch(ErrorActions.setNewsForMoment({
                type: ErrorEnumType.NewsType.SUCCESS,
                message: i18n.t('forms:updateUserSuccess')
            }));
            dispatch(clearCreateUserStatus());

            const {USER_MANAGEMENT} = ViewManagementModule.EnumTypes.Page;
            history.push(`${Dictionary.PageUrl.get(USER_MANAGEMENT)}`);
        } catch (err) {
            dispatch(createUserFailure(err && err.response ? err.response.data : null));
        }
    };
}

function deleteUser(userId: number) {
    return async dispatch => {
        dispatch(ViewManagementModule.Actions.showLoader());
        await UserModule.Connector.deleteUser(userId);
        dispatch(deleteUserSuccess());
        await dispatch(getUserList());
        dispatch(ViewManagementModule.Actions.hideLoader());
    };
}

function completeUserActivation(newUserData: UserModule.Types.ActivateUserRequest) {
    return async dispatch => {
        try {
            await UserModule.Connector.activateUserComplete(newUserData);
            dispatch(reset('activateUserCompleteForm'));
            dispatch(completeUserActivationSuccess());
        } catch (err) {
            dispatch(completeUserActivationFailure(err && err.response ? err.response.data : null));
        }
    };
}

function beginUserActivation(formData: UserModule.Types.RequestPasswordResetRequest) {
    return async dispatch => {
        try {
            await UserModule.Connector.activateUserBegin(formData);
            dispatch(reset('activateUserBegin'));
            dispatch(beginUserActivationSuccess());
        } catch (err) {
            dispatch(beginUserActivationFailure(err && err.response ? err.response.data : null));
        }
    };
}

function getUserList(queryParams?: Array<{ key: any; value: any }>, filterQuery?: boolean) {
    return async dispatch => {
        try {
            const userList = await UserModule.Connector.getUserList(queryParams ? queryParams : null);
            if (filterQuery) {
                dispatch(getUserListWithFiltersSuccess(userList.data.userList));
            } else {
                dispatch(getUserListSuccess(userList.data.userList));
            }

            dispatch(InfinityTableModule.Actions.setInfinityTableCount(userList.data.userList.length));
        } catch (err) {
            dispatch(getUserListFailure(err && err.response ? err.response.data : null));
        }
    };
}

function getFleetUsers(queryParams?: URLSearchParams) {
    return async dispatch => {
        try {
            const userList = await UserModule.Connector.getFleetUsers(queryParams ? queryParams : null);
            dispatch(getUserListSuccess(userList.data.userList));

            dispatch(InfinityTableModule.Actions.setInfinityTableCount(userList.data.userList.length));
            return userList.data
        } catch (err) {
            dispatch(getUserListFailure(err && err.response ? err.response.data : null));
        }
    };
}

function getUserById(userId: number) {
    return async dispatch => {
        try {
            const userObj = await UserModule.Connector.getUserById(userId);
            //dispatch(getUserByIdSuccess());
            dispatch(setActiveUser(userObj.data.user));
        } catch (err) {
            dispatch(getUserByIdFailure(err && err.response ? err.response.data : null));
        }
    };
}

function getUserByIdSuccess(): UserActionModel.GetUserByIdSuccessAction {
    return {
        type: ActionTypes.User.GET_USER_BY_ID_SUCCESS
    };
}

function getUserByIdFailure(error: UserModule.Types.Error): UserActionModel.GetUserByIdFailureAction {
    return {
        type: ActionTypes.User.GET_USER_BY_ID_FAILURE,
        payload: {
            error
        }
    };
}

// function setRoleFilter(userRole: UserModule.UserEnumTypes.RoleName) {
//     return async dispatch => {
//         try {
//             // setUserRoleFilter(userRole);
//             await dispatch(setUserRoleFilter(userRole));
//         } catch (err) {
//             dispatch(getUserListFailure(err && err.response ? err.response.data : null));
//         }
//     };
// }

function setUserRoleFilter(userRole: UserModule.UserEnumTypes.RoleName): UserActionModel.SetRoleFilter {
    return {
        type: ActionTypes.User.SET_ROLE_FILTER,
        payload: {
            userRole
        }
    };
}

function blockUser(userId: number) {
    return async dispatch => {
        try {
            dispatch(blockActiveUser());
            await UserModule.Connector.blockUser(userId);
            dispatch(blockUserSuccess());
            // dispatch(getUserList());
        } catch (err) {
            dispatch(blockUserFailure(err && err.response ? err.response.data : null));
        }
    };
}

function unblockUser(userId: number) {
    return async dispatch => {
        try {
            dispatch(unblockActiveUser());
            await UserModule.Connector.unblockUser(userId);
            dispatch(unblockUserSuccess());
            // dispatch(getUserList());
        } catch (err) {
            dispatch(unblockUserFailure(err && err.response ? err.response.data : null));
        }
    };
}

function getVoivodeships() {
  return async (dispatch, getState) => {
    const voivodeships = getState().userStore.provinces

    if (voivodeships.length > 0) {
      return
    }

    try {
      dispatch(ViewManagementModule.Actions.showLoader());

      const voivodeshipsResponse = await APIModule.Region.Connectors.getVoivodeships();
      dispatch(updateVoivodeship(voivodeshipsResponse.data))
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(ViewManagementModule.Actions.hideLoader());
    }
  }
}

function getCounties(provinces: Province[]) {
  return async (dispatch, getState) => {
    if (provinces.length === 0) {
      dispatch(updateCounties([]))
      dispatch(change('addUserForm', 'counties', []))

      return
    }

    try {
      dispatch(ViewManagementModule.Actions.showLoader());

      const params = new URLSearchParams();
      provinces.forEach(province => {
        params.append('provinces', province)
      })

      const countiesResponse = await APIModule.Region.Connectors.getCountiesByVoivodeship(params);
      const fetchedCounties = countiesResponse.data.counties

      const { counties }: { counties?: OptionsElement[] } = getState().form?.addUserForm?.values ?? {}

      if (counties?.length > 0) {
        const onlyExistingCountiesInResponse = counties
          .filter((county) => fetchedCounties.findIndex(({ id }) => county.value === id) > -1)

        dispatch(change('addUserForm', 'counties', onlyExistingCountiesInResponse, true))
      }

      dispatch(updateCounties(fetchedCounties))
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(ViewManagementModule.Actions.hideLoader());
    }
  }
}

// SUCCESS | FAILURE ACTIONS

function noActiveUserFound() {
    return {
        type: ActionTypes.User.NO_ACTIVE_USER_FOUND
    };
}

function loginUserSuccess(data: UserModule.Types.LoginResponse): UserActionModel.LoginUserSuccessAction {
    localStorage.setItem('token', data.token);
    API.defaults.headers.common['Authorization'] = `bearer ${data.token}`;
    return {
        type: ActionTypes.User.LOG_IN_SUCCESS,
        payload: {
            ...data
        }
    };
}

// niepotrzebna póki co dalsza tego obsługa
function loginUserSuccessNotPermission(): UserActionModel.LoginUserSuccessNotPermissionAction {
    return {
        type: ActionTypes.User.LOG_IN_SUCCESS_NOT_PERMISSION
    };
}

function loginUserFailure(error: UserModule.Types.Error): UserActionModel.LoginUserFailureAction {
    return {
        type: ActionTypes.User.LOG_IN_FAILURE,
        payload: {
            error
        }
    };
}

function resetPasswordSuccess(): UserActionModel.ResetPasswordSuccessAction {
    return {
        type: ActionTypes.User.RESET_PASSWORD_SUCCESS
    };
}

function resetPasswordFailure(error: UserModule.Types.Error): UserActionModel.ResetPasswordFailureAction {
    return {
        type: ActionTypes.User.RESET_PASSWORD_FAILURE,
        payload: {
            error
        }
    };
}

function resetPasswordConfirmSuccess(): UserActionModel.ResetPasswordConfirmSuccessAction {
    return {
        type: ActionTypes.User.RESET_PASSWORD_CONFIRM_SUCCESS
    };
}

function resetPasswordConfirmFailure(error: UserModule.Types.Error): UserActionModel.ResetPasswordConfirmFailureAction {
    return {
        type: ActionTypes.User.RESET_PASSWORD_CONFIRM_FAILURE,
        payload: {
            error
        }
    };
}

function logOutUser(): UserActionModel.LogOutUserAction {
    localStorage.clear();
    API.defaults.headers.common['Authorization'] = ``;
    return {
        type: ActionTypes.User.LOG_OUT
    };
}

function changePasswordSuccess(): UserActionModel.ChangePasswordSuccessAction {
    return {
        type: ActionTypes.User.CHANGE_PASSWORD_SUCCESS
    };
}

function changePasswordFailure(error: UserModule.Types.Error): UserActionModel.ChangePasswordFailureAction {
    return {
        type: ActionTypes.User.CHANGE_PASSWORD_FAILURE,
        payload: {
            error
        }
    };
}

function createUserSuccess(): UserActionModel.CreateUserSuccessAction {
    return {
        type: ActionTypes.User.CREATE_USER_SUCCESS
    };
}

function createUserFailure(error: UserModule.Types.Error): UserActionModel.CreateUserFailureAction {
    return {
        type: ActionTypes.User.CREATE_USER_FAILURE,
        payload: {
            error
        }
    };
}

function completeUserActivationSuccess(): UserActionModel.ActivateUserSuccessAction {
    return {
        type: ActionTypes.User.ACTIVATE_USER_SUCCESS
    };
}

function completeUserActivationFailure(error: UserModule.Types.Error): UserActionModel.ActivateUserFailureAction {
    return {
        type: ActionTypes.User.ACTIVATE_USER_FAILURE,
        payload: {
            error
        }
    };
}

function beginUserActivationSuccess(): UserActionModel.BeginActivateUserSuccessAction {
    return {
        type: ActionTypes.User.BEGIN_ACTIVATE_USER_SUCCESS
    };
}

function beginUserActivationFailure(error: UserModule.Types.Error): UserActionModel.BeginActivateUserFailureAction {
    return {
        type: ActionTypes.User.BEGIN_ACTIVATE_USER_FAILURE,
        payload: {
            error
        }
    };
}

function getUserListSuccess(userList: Array<UserModule.Types.UserDto>): UserActionModel.GetUserListSuccessAction {
    return {
        type: ActionTypes.User.GET_USER_LIST_SUCCESS,
        payload: {
            userList
        }
    };
}

function getUserListWithFiltersSuccess(userList: Array<UserModule.Types.UserDto>): UserActionModel.GetUserListWithFiltersSuccessAction {
    return {
        type: ActionTypes.User.GET_USER_LIST_WITH_FILTERS_SUCCESS,
        payload: {
            userList
        }
    };
}

function getUserListFailure(error: UserModule.Types.Error): UserActionModel.GetUserListFailureAction {
    return {
        type: ActionTypes.User.GET_USER_LIST_FAILURE,
        payload: {
            error
        }
    };
}

function clearUserList(): UserActionModel.GetUserListWithFiltersSuccessAction {
    return {
        type: ActionTypes.User.GET_USER_LIST_WITH_FILTERS_SUCCESS,
        payload: {
            userList: []
        }
    };
}

function blockUserSuccess(): UserActionModel.BlockUserSuccessAction {
    return {
        type: ActionTypes.User.BLOCK_USER_SUCCESS
    };
}

function blockUserFailure(error: UserModule.Types.Error): UserActionModel.BlockUserFailureAction {
    return {
        type: ActionTypes.User.BLOCK_USER_FAILURE,
        payload: {
            error
        }
    };
}

function unblockUserSuccess(): UserActionModel.UnblockUserSuccessAction {
    return {
        type: ActionTypes.User.UNBLOCK_USER_SUCCESS
    };
}

function unblockUserFailure(error: UserModule.Types.Error): UserActionModel.UnblockUserFailureAction {
    return {
        type: ActionTypes.User.UNBLOCK_USER_FAILURE,
        payload: {
            error
        }
    };
}

function deleteUserSuccess(): UserActionModel.DeleteUserSuccess {
    return {
        type: ActionTypes.User.DELETE_USER_SUCCESS
    };
}

function setActiveUser(activeUser: UserModule.Types.UserDto): UserActionModel.SetActiveUser {
    return {
        type: ActionTypes.User.SET_ACTIVE_USER,
        payload: {
            activeUser
        }
    };
}

function clearCreateUserStatus() {
    return {
        type: ActionTypes.User.CLEAR_CREATE_USER_STATUS
    };
}

function blockActiveUser() {
    return {
        type: ActionTypes.User.BLOCK_ACTIVE_USER
    };
}

function unblockActiveUser() {
    return {
        type: ActionTypes.User.UNBLOCK_ACTIVE_USER
    };
}

function updateVoivodeship(voivodeships: GetVoivodeshipResponse) {
  return {
    type: ActionTypes.User.UPDATE_VOIVODESHIPS,
    payload: {
      voivodeships
    }
  }
}

function updateCounties(counties: GetCountiesResponse['counties']) {
  return {
    type: ActionTypes.User.UPDATE_COUNTIES,
    payload: {
      counties
    }
  }
}

export {
    loginUser,
    checkUser,
    logOutUser,
    resetPassword,
    resetPasswordConfirm,
    changePassword,
    createUser,
    completeUserActivation,
    beginUserActivation,
    getUserList,
    blockUser,
    unblockUser,
    deleteUser,
    setActiveUser,
    clearCreateUserStatus,
    // setRoleFilter
    setUserRoleFilter,
    getUserById,
    checkIfTokenIsNotExpired,
    updateUser,
    getVoivodeships,
    getCounties,
    clearUserList,
    getFleetUsers
};



// WEBPACK FOOTER //
// ./src/Redux/Actions/UserActions.ts